// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZvfO","col":"styles_col__1AO77"};